<template>
  <v-container class="insurance-assets-and-liabilities-container">
    <v-container class="pa-0">
      <v-row class="title-section" no-gutters>
        <v-col cols="12" sm="1" class="d-flex align-center">
          <router-link
            :to="{ name: 'EstimatedInsuranceRequiredInput' }"
            class="back-arrow"
            ><v-icon large color="mid-grey" class="">{{
              icons.mdiArrowLeft
            }}</v-icon></router-link
          >
        </v-col>
        <v-col cols="12" sm="11" class="d-flex align-center">
          <h1>Estimated Estate Administration Costs</h1>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-sm-6">
        <v-col cols="12" md="4" offset-md="1" class="form-blurb">
          <ColumnLayoutText :sections="leftColumnInformation" />
        </v-col>
        <v-col cols="12" md="7">
          <div class="left-section-container">
            <div class="administration-costs-components-section">
              <div class="administration-costs-component-container">
                <div
                  class="administration-costs-component-container-title-section"
                  :style="
                    $vuetify.breakpoint.mdAndDown
                      ? 'padding-left: 0px; padding-right:0px;'
                      : 'padding-left: 30px; padding-right:30px;'
                  "
                >
                  <div>
                    <h1>Estate Administration Services</h1>
                  </div>
                </div>

                <AdministrationCosts
                  @summaryClicked="summaryClicked"
                  :testator="testator"
                />
              </div>
              <div class="estate-duty-costs-component-container">
                <EstateDutyCosts :testator="testator" />
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    &nbsp;
    <v-divider />
    <v-container>
      &nbsp;
      <v-row no-gutters>
        <v-col cols="12" sm="1"> </v-col>
        <v-col cols="12" sm="11">
          <h1 id="need-assistance-title" class="mb-2">
            Need assistance to cover your costs?
          </h1>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-sm-6">
        <v-col cols="12" md="4" offset-sm="1" class="form-blurb"> </v-col>
        <v-col cols="12" md="7">
          <div class="left-section-container">
            <ValidationObserver ref="observer">
              <div class="insurance-asset-block">
                <v-row no-gutters>
                  <v-col cols="12" sm="12" md="12">
                    <p>
                      We offer an affordable solution that covers the costs
                      associated with winding up your estate and helps your
                      family pay off any debts that you have.
                    </p>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="4"
                        md="5"
                        lg="7"
                        :class="{ 'mb-3': isMobile }"
                      >
                        <h4 class="field-label">Monthly income</h4>
                        <strong>(before tax and deductions)</strong>
                      </v-col>
                      <v-col cols="12" sm="8" md="7" lg="5">
                        <ValidationProvider
                          id="monthly_income_value"
                          v-slot="{ errors }"
                          name="monthly_income_value"
                          rules="required"
                        >
                          <TextField
                            v-model="currencyMonthlyIncome"
                            :prefix="'R'"
                            :pattern="'[0-9\s]*'"
                            @keypress="isNumber($event)"
                            :errors="errors"
                            :name="'outstanding_debt'"
                          />
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="4"
                        md="5"
                        lg="7"
                        :class="{ 'mb-3': isMobile }"
                      >
                        <h4 class="field-label">Highest Education Level</h4>
                      </v-col>
                      <v-col cols="12" sm="8" md="7" lg="5">
                        <ValidationProvider
                          id="education_level"
                          v-slot="{ errors }"
                          name="education_level"
                          rules="required"
                        >
                          <ListSelect
                            v-model="educationLevel"
                            :errors="errors"
                            :items="insuranceQuestionEducationLevels"
                            :label="'Education Level'"
                            :name="'education_level'"
                          />
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" sm="4" md="5" lg="7">
                        <h4 class="field-label">Are you a smoker?</h4>
                        <p class="ma-0">
                          (or have you smoked in the last 12 months)
                        </p>
                      </v-col>
                      <v-col cols="12" sm="8" md="7" lg="5">
                        <ValidationProvider
                          id="smoker"
                          v-slot="{ errors }"
                          name="smoker"
                          rules="required"
                        >
                          <RadioSelect
                            v-if="whitelabel.omDesign"
                            v-model="smoker"
                            :items="[
                              { value: true, text: 'Yes' },
                              { value: false, text: 'No' },
                            ]"
                            :errors="errors"
                            :name="'smoker'"
                            :group="'smoker'"
                          />
                          <SmokingInput v-else v-model="smoker" />
                          <!-- <v-text-field
                            id="non-smoker"
                            v-model="smoker"
                            :error-messages="errors"
                            type="text"
                            pattern="[0-9\s]*"
                          /> -->
                        </ValidationProvider>
                      </v-col>
                    </v-row>

                    <v-row v-if="children.length" no-gutters>
                      <v-col cols="12" sm="4" md="5" lg="7">
                        <h4 class="field-label">Gender of children</h4>
                      </v-col>
                    </v-row>

                    <v-row v-if="children.length" no-gutters class="mt-sm-6">
                      <v-col cols="12" sm="12">
                        <v-row no-gutters class="insurance-asset-block">
                          <v-col cols="12">
                            <v-row
                              v-for="child in children"
                              :key="child.id"
                              no-gutters
                            >
                              <v-col cols="12" sm="12" md="6" lg="6">
                                <p class="field-label">{{ child.fullName }}</p>
                              </v-col>
                              <v-col cols="12" sm="12" md="6" lg="6">
                                <ValidationProvider
                                  :id="'gender-child-' + child.id"
                                  v-slot="{ errors }"
                                  :name="'gender-child-' + child.id"
                                  rules="required"
                                >
                                  <RadioSelect
                                    v-model="child.gender"
                                    :items="[
                                      { value: 'MALE', text: 'Male' },
                                      { value: 'FEMALE', text: 'Female' },
                                    ]"
                                    :errors="
                                      errors.length == 0
                                        ? ''
                                        : 'Gender is required.'
                                    "
                                    :name="'gender-child-' + child.id"
                                    :group="'gender-child-' + child.id"
                                  />
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <v-row no-gutters class="free-insurance-button-container">
                <DefaultButton
                  @defaultButtonClicked="backClicked"
                  :callout="'left'"
                  :small="true"
                  style="margin-right: 20px"
                />

                <GradientButton
                  class=""
                  @gradientButtonClicked="submit"
                  :title="'Next'"
                  :small="true"
                  :callout="'right'"
                  :loading="buttonLoadingNext"
                />
              </v-row>
            </ValidationObserver>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
  import { isNumberCheck } from '../../constants/js/currency-input';
  import SmokingInput from './SmokingInput.vue';
  import { insuranceQuestionEducationLevels } from '../../constants/js/insurance';
  import AdministrationCosts from './AdministrationCosts.vue';
  import EstateDutyCosts from './EstateDutyCosts.vue';
  import ColumnLayoutText from '../common/ColumnLayoutText.vue';
  import {
    formatCurrency,
    parseCurrency,
  } from '../../constants/js/currency-input';

  export default {
    name: 'EstimatedInsuranceRequiredInput',
    components: {
      SmokingInput,
      AdministrationCosts,
      EstateDutyCosts,
      ColumnLayoutText,
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
      peopleRelations: {
        type: Object,
        required: true,
      },
      buttonLoading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        smoker: null,
        monthlyIncome: null,
        educationLevel: null,
        insuranceQuestionEducationLevels: insuranceQuestionEducationLevels,
        buttonLoadingNext: false,
        buttonLoadingSkipToWill: false,
        gender: null,
        children: this.peopleRelations.children.filter(
          child => child.gender === null
        ),
      };
    },
    computed: {
      leftColumnInformation() {
        return [
          {
            title: `Estate Administration Service Costs`,
            paragraphs: [
              {
                text: 'These cover the essential tasks of managing and finalising an estate after someone passes away. These costs include executor fees, legal fees, and other professional services needed to ensure the estate is distributed according to the will.',
              },
              {
                text: `These fees are unavoidable and vary based on the estate's complexity and size.`,
              },
            ],
          },
          {
            title: `Estate Duties and Taxes`,
            paragraphs: [
              {
                text: `Estate duties and taxes are charges by the government when assets are passed from the deceased to their beneficiaries. These can include estate duty, capital gains tax, and other fees depending on the estate's value. Planning for these costs is important, as they can reduce the amount your loved ones will inherit.`,
              },
            ],
          },
        ];
      },
      currencyMonthlyIncome: {
        get: function () {
          return formatCurrency(this.monthlyIncome);
        },
        set: function (newValue) {
          this.monthlyIncome = parseCurrency(newValue);
        },
      },
      isMobile() {
        return this.$isMobileDevice();
      },
    },
    watch: {
      buttonLoading(value) {
        if (!value) {
          this.buttonLoadingNext = false;
          this.buttonLoadingSkipToWill = false;
        }
      },
    },
    created() {
      this.setExistingFields();
    },
    methods: {
      summaryClicked() {
        const element = document.getElementById('need-assistance-title');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      },
      backClicked() {
        this.$router.push({ name: 'EstimatedInsuranceRequiredInput' });
      },
      submit() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.requestAQuote();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      requestAQuote() {
        const insuranceInputDetails = {
          testatorId: this.testator.id,
          monthlyIncome: parseInt(this.monthlyIncome),
          smoker: this.smoker,
          educationLevel: this.educationLevel,
        };

        const peopleInputDetails = {
          people: this.children.map(child => {
            return {
              id: child.id,
              gender: child.gender,
            };
          }),
        };

        const params = {
          insuranceInputDetails: insuranceInputDetails,
          redirectLocation: 'InsuranceProducts',
          deletedNominatedBeneficiary: null,
          peopleInputDetails: peopleInputDetails,
        };
        this.buttonLoadingNext = true;

        this.$emit('updateInsuranceAndRequestQuotes', params);
      },
      setExistingFields() {
        const insurance = this.testator.insurance;
        if (insurance) {
          this.educationLevel = insurance.educationLevel;
          this.monthlyIncome = insurance.monthlyIncome;
          this.smoker = insurance.smoker;
        }
      },
      skip() {
        const insuranceInputDetails = {
          testatorId: this.testator.id,
          skipInsurance: true,
        };
        const params = {
          insuranceInputDetails: insuranceInputDetails,
          redirectLocation: 'OverviewPage',
        };
        this.buttonLoadingSkipToWill = true;
        this.$emit('updateInsurance', params);
      },
      isNumber(event) {
        isNumberCheck(event);
      },
    },
  };
</script>

<style lang="scss">
  .insurance-assets-and-liabilities-container {
    .left-section-container {
      .insurance-asset-block {
        #smoker {
          .v-input__slot {
            display: none;
          }
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .insurance-assets-and-liabilities-container {
    .title-section {
      h1 {
        margin: 0;
        color: #282828;
      }
    }
    .left-section-container {
      padding-left: 60px;
    }

    .mobile-column-layout {
      display: none;
    }

    .administration-costs-components-section {
      box-shadow: 0px 24px 38px 0px #00000024;
    }

    .estate-duty-costs-component-container {
      padding-top: 24px;
      background-color: white;
    }

    .administration-costs-component-container {
      padding-top: 40px;
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 40px;

      .administration-costs-component-container-title-section {
        div {
          margin-bottom: 20px !important;
          h1 {
            font-size: 24px !important;
            font-weight: 600 !important;
            line-height: 28px !important;
            margin-bottom: 8px !important;
          }
        }
      }
    }
  }

  .insurance-assets-and-liabilities-container {
    .insurance-asset-block {
      // border in global.scss because of IE issue
      border-radius: 0;
      padding: 15px 20px;
      margin-bottom: 20px;
    }

    .field-label {
      margin-top: 18px;
    }

    .insurance-assets-and-liabilities-container .insurance-asset-block strong {
      font-size: 13px;
    }

    .insurance-assets-and-liabilities-container
      .insurance-asset-block
      .smoker-icon-container {
      width: 24px;
    }

    .insurance-assets-and-liabilities-container
      .insurance-asset-block
      .smoker-icon-parent {
      cursor: pointer;
    }

    .insurance-assets-and-liabilities-container
      .insurance-asset-block
      .smoker-icon-parent:first-of-type {
      margin-right: 12px;
    }

    .insurance-assets-and-liabilities-container
      .insurance-asset-block
      .smoker-icon-container:first-of-type {
      margin-right: 8px;
    }

    .insurance-assets-and-liabilities-container
      .insurance-asset-block
      .smoker-section {
      padding-top: 18px;
    }

    #smoker input {
      display: none;
    }

    #smoker .v-input {
      margin: 0;
      padding: 0;
    }

    #smoker .v-input__slot::before {
      display: none;
      width: 0;
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .insurance-assets-and-liabilities-container {
      .title-section {
        margin-top: 12px;
      }

      padding: 0;

      .container {
        padding: 0;
      }

      .left-section-container {
        padding-left: 0;
      }
      .desktop-column-layout {
        display: none;
      }
      .mobile-column-layout {
        display: block;
      }

      .administration-costs-component-container {
        background-color: white;
        padding-left: 14px;
        padding-right: 14px;
      }
    }
  }
</style>
